import React from 'react';

export default function TaxDeclarationPolicy() {
  return (
    <div className="bg-white text-gray-800 min-h-screen py-12 px-4">
      <div className="max-w-4xl mx-auto space-y-10">
        <h1 className="text-3xl text-center font-bold text-purple-600">Tax Declaration & Reporting Policy</h1>

        <p className="text-gray-700">
          Million2Trillion (M2T) operates as a global financial services marketplace and fully complies with international tax regulations. Every monetized user is responsible for full tax declaration and compliance within their legal jurisdiction.
        </p>

        <div className="space-y-6">
          <h2 className="text-2xl font-semibold text-purple-500">User Tax Responsibility</h2>
          <ul className="list-disc space-y-2 pl-6 text-gray-700">
            <li>All members earning revenue from M2T through education, signals, advisory, or any other monetization models are responsible for reporting such income to their local tax authorities.</li>
            <li>Tax rates, income thresholds, VAT, GST, or withholding obligations vary depending on the member’s country of residence and business registration.</li>
            <li>M2T may request tax documentation (W-8BEN, W-9, VAT IDs, etc.) prior to activating any payout services.</li>
          </ul>
        </div>

        <div className="space-y-6">
          <h2 className="text-2xl font-semibold text-purple-500">M2T Platform Tax Reporting</h2>
          <ul className="list-disc space-y-2 pl-6 text-gray-700">
            <li>M2T will generate annual earning reports, transaction statements, and payout records accessible through each verified member dashboard.</li>
            <li>Where legally required, M2T may file platform-level income summaries to tax authorities in specific jurisdictions (UAE, US, EU, etc.).</li>
            <li>Independent tax advisors should be consulted for proper individual and corporate reporting preparation by members.</li>
          </ul>
        </div>

        <div className="space-y-6">
          <h2 className="text-2xl font-semibold text-purple-500">International Tax Cooperation Compliance</h2>
          <ul className="list-disc space-y-2 pl-6 text-gray-700">
            <li>M2T may cooperate with government agencies under treaties such as CRS (Common Reporting Standards), FATCA (US Foreign Account Tax Compliance), or local tax sharing laws when applicable.</li>
            <li>Failure to submit proper tax declarations may lead to account restrictions or payout holds for compliance protection.</li>
          </ul>
        </div>

        <div className="space-y-6">
          <h2 className="text-2xl font-semibold text-purple-500">Non-Refundable Tax Withholding</h2>
          <ul className="list-disc space-y-2 pl-6 text-gray-700">
            <li>Any tax withholding deducted at source (if applicable) may not be refundable by M2T and should be claimed via your tax authority filings directly.</li>
          </ul>
        </div>

        <p className="text-gray-500 italic pt-6">
          M2T provides verified professionals with transparent earning statements. The final tax filing responsibility belongs to each member according to applicable tax laws.
        </p>
      </div>
    </div>
  );
}
